import { Link } from "react-router-dom";
import { CalendarDays, Gamepad2, Map } from "lucide-react";
import { StatusBadge } from "@/components/common";
import { fmtDateTime } from "@/lib/format";

export function EventCard({ ev, index = 0 }) {
  return (
    <Link to={`/eventi/${ev.slug}`} data-testid={`event-card-${ev.slug}`} className="group nx-card nx-card-hover overflow-hidden flex flex-col fade-up" style={{ animationDelay: `${index * 60}ms` }}>
      <div className="relative aspect-[16/9] overflow-hidden bg-[#17171D]">
        <img src={ev.poster_url || "/images/texture.jpg"} alt={`Locandina ${ev.title}`} loading="lazy" className="w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-[1.03] transition-[opacity,transform] duration-500" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0F] via-transparent to-transparent" />
        <div className="absolute top-3 left-3"><StatusBadge status={ev.status} /></div>
      </div>
      <div className="p-5 flex-1 flex flex-col">
        <h3 className="font-display font-bold uppercase text-lg text-[#F5F5F7] leading-tight group-hover:text-[#d6b3ff] transition-colors duration-200">{ev.title}</h3>
        <div className="mt-4 space-y-1.5 text-xs text-[#C6C6CE]/70">
          <div className="flex items-center gap-2"><CalendarDays className="w-3.5 h-3.5 text-[#962FFF]" />{fmtDateTime(ev.start_at)}</div>
          {(ev.mode || ev.format) && <div className="flex items-center gap-2"><Gamepad2 className="w-3.5 h-3.5 text-[#962FFF]" />{[ev.mode, ev.format].filter(Boolean).join(" · ")}</div>}
          {ev.map && <div className="flex items-center gap-2"><Map className="w-3.5 h-3.5 text-[#962FFF]" />{ev.map}</div>}
        </div>
      </div>
    </Link>
  );
}
